export default __webpack_public_path__ + "static/media/tr.31b0d6e5.png";